export default function initExpandContent () {
  const $title = $('.js__expand--title');

  $title.on('click', function (event) {
    event.preventDefault();
    const $this = $(this),
      parent = $this.data('parent'),
      $elem = $(this).closest(parent);
    $elem.toggleClass('active');
  });
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/poi/expandContent.js